import { tz } from '@date-fns/tz';
import { isValid, parse } from 'date-fns';
import {
  HOLIDAY_SHIPPING_NOTICE_SCHEDULE,
  HOLIDAY_SHIPPING_NOTICE_TIMEZONE,
  type HolidayShippingNoticeSchedule,
} from '../../constants/campaign/holidayShippingNotice';

const HOLIDAY_SHIPPING_NOTICE_DATE_PATTERN = 'yyyy-MM-dd HH:mm:ss';

/** Parses a `yyyy-MM-dd HH:mm:ss` wall-clock time as an SGT instant */
const parseScheduleDate = (value: string): Date =>
  parse(value, HOLIDAY_SHIPPING_NOTICE_DATE_PATTERN, new Date(), { in: tz(HOLIDAY_SHIPPING_NOTICE_TIMEZONE) });

interface IsHolidayShippingNoticeActiveParams {
  /** Current client time for this informational notice */
  now: Date;
  schedule?: HolidayShippingNoticeSchedule;
}

/** Whether the Chuseok shipping notice shows at `now` */
export const isHolidayShippingNoticeActive = ({
  now,
  schedule = HOLIDAY_SHIPPING_NOTICE_SCHEDULE,
}: IsHolidayShippingNoticeActiveParams): boolean => {
  const startAt = parseScheduleDate(schedule.startAt);
  const endAt = parseScheduleDate(schedule.endAt);

  // A malformed date compares false against everything, which would show the notice at the wrong time
  if (!isValid(startAt) || !isValid(endAt)) {
    return false;
  }

  return startAt <= now && now < endAt;
};
